import z from 'zod';
import { activationStatusSchema as osActivationStatusSchema } from '@getvim/vim-os-api';

const activationStatusSchema = osActivationStatusSchema;

export type ActivationStatus = z.infer<typeof activationStatusSchema>;

export const ActivationStatus = activationStatusSchema.enum;
